export class PrintSymbol {
    text!: string;

    setSymbol(symbol: string): PrintSymbol {
        this.text = symbol;
        return this;
    }
}